import { Tab, TabList, TabPanels, Tabs, TabsProps } from '@chakra-ui/react'
import { TabPanelsProps } from '@chakra-ui/react'

import { useViewWidgetState } from '../../store/appStore/view/useViewWidgetState'
import { createWidget } from '../widget-utils'

export type TabGroupWidgetProps = Partial<TabsProps> & {
  tabLabels?: string[]
  isLoading?: boolean
} & TabPanelsProps

export const TabGroupWidget = ({
  tabLabels = [],
  style,
  children,
  defaultIndex = 0,
  isLoading,
  ...props
}: TabGroupWidgetProps) => {
  const [{ tabIndex }, setWidgetState] = useViewWidgetState({
    persist: true,
    state: {
      tabIndex: defaultIndex,
    },
  })

  return (
    <Tabs
      display="flex"
      flexDirection="column"
      flex="1"
      m="24px 0 0px 0px"
      defaultIndex={tabIndex}
      onChange={index => setWidgetState({ tabIndex: index })}
    >
      <TabList>
        {tabLabels.map((label, index) => (
          <Tab key={index}>{label}</Tab>
        ))}
      </TabList>
      <TabPanels display="flex" flexDirection="column" flex="1" {...props}>
        {children}
      </TabPanels>
    </Tabs>
  )
}

export const TabGroupWidgetDefinition = createWidget(TabGroupWidget, {
  type: 'TabGroup',
})
